import React from 'react';
import ReactSelect from 'react-select';
import styled from 'styled-components';
import theme from 'theme/theme';

const Select = ({ ...other }) => (
  <ReactSelect
    className="react-select"
    classNamePrefix="react-select"
    {...other}
  />
);

export default styled(Select)`

  // input
  .react-select__control {
    box-sizing: border-box;
    width: 100%;
    padding: 4px 20px;
    border: 1px solid ${theme.colors.mediumLight};
    border-radius: 0;
    box-shadow: none;
    color: ${theme.colors.black};
    background: ${theme.colors.white};
    font-size: ${theme.fontSizes.default};
    outline-offset: -3px;
    &:focus,
    &--is-focused {
      outline: none;
    }
  }
  .react-select__value-container {
    padding: 0;
  }
  
  // single values
  .react-select__single-value {
    color: ${theme.colors.black};
  }
  
  // selected multi values
  .react-select__multi-value {
    background: ${theme.colors.light};
    border-radius: 5px;
    &__label {
      color: ${theme.colors.black};
    }
    &__remove {
      color: ${theme.colors.medium};
      border-radius: 0;
      &:hover {
        color: #fff;
        background: ${theme.colors.primary};
        cursor: pointer;
      }
    }
  }
  
  // options
  .react-select__menu {
    margin: 0;
    border: 0;
    border-radius: 0;
    box-shadow: ${theme.shadows.default};
  }
  .react-select__menu-list {
    border: 0;
    padding: 0;
    border-radius: 0;
    background: ${theme.colors.medium};
    color: ${theme.colors.white};
  }
  .react-select__option {
    padding: 7px 20px;
    &:hover,
    &--is-focused {
      background: ${theme.colors.primary};
      color: ${theme.colors.white};
      cursor: pointer;
    }
  }


`;
